export default __webpack_public_path__ + "static/4-ecaa3e6ecb03823e169a0deef990cf2c.jpg";